import {
    Component,
    Input,
    Output,
    EventEmitter,
    Directive,
    OnInit,
    OnDestroy,
    ViewChild,
    ElementRef,
    SimpleChanges,
    OnChanges
} from '@angular/core';
import {config} from 'rxjs/internal/config';
import {forEach} from '@angular/router/src/utils/collection';
import {unescape} from 'querystring';
import {group, style} from '@angular/animations/src/animation_metadata';
import {MulticastOperator} from 'rxjs/internal/operators/multicast';

declare var $: any;

@Component({
    selector: 'data-table',
    templateUrl: './data-table.component.html',
    styleUrls: ['./data-table.component.scss']
})
export class DataTableComponent implements OnInit, OnDestroy, OnChanges {

    @ViewChild('popup') popupRef: ElementRef;
    @ViewChild('search') searchRef: ElementRef;
    @ViewChild('sel') selectRef: ElementRef;

    @ViewChild('_thead') headerRef: ElementRef;
    @ViewChild('_table') tableRef: ElementRef;
    @ViewChild('_tfoot') footerRef: ElementRef;

    @Input() configs: Array<DataTableConfig> = null;

    public config: DataTableConfig = null;
    public data: Array<any> = null;
    public filtered: Array<any> = null;
    public groups: Array<any> = null;
    public footer: any = null;

    private positioningEH = this.positioning.bind(this);

    private static instances: Array<DataTableComponent> = [];

    public static handleDOMChange() {

        DataTableComponent.instances.forEach(i => {
            i.sizing();
            i.calculate();
            i.positioning();
        });
    }

    dom() {
        DataTableComponent.handleDOMChange();
    }

    ngOnInit() {

        DataTableComponent.instances.push(this);

        if (DataTableComponent.instances.length == 1) {
            window.addEventListener("resize", DataTableComponent.handleDOMChange);
        }

        window.addEventListener("scroll", this.positioningEH);

        this.select();
    }

    ngOnChanges(changes: SimpleChanges) {
        this.select();
    }

    ngOnDestroy() {

        window.removeEventListener("scroll", this.positioningEH);

        DataTableComponent.instances = DataTableComponent.instances.filter(i => i != this);

        if (DataTableComponent.instances.length == 0) {
            window.removeEventListener("resize", DataTableComponent.handleDOMChange);
        }
    }

    sizing() {

        if (typeof this.tableRef != 'undefined') {
            let src = $(this.tableRef.nativeElement).find('th.dummy');

            if (src.length > 0) {

                let ths = typeof this.headerRef != 'undefined' ? $(this.headerRef.nativeElement).find('th') : null;
                let tds = typeof this.footerRef != 'undefined' ? $(this.footerRef.nativeElement).find('td') : null;

                if (ths != null || tds != null) src.each(i => {

                    let w = $(src[i]).outerWidth();

                    if (ths != null) $(ths[i]).css({width: w});
                    if (tds != null) $(tds[i]).css({width: w})
                });
            }
        }
    }

    private info = {

        hdMin: null,
        hdMax: null,
        hdHeight: null,
        hd: null,

        ftMin: null,
        ftMax: null,
        ftHeight: null,
        ft: null,

        nav: null,
    }

    calculate() {

        this.info.nav = $('.topnavbar').height();

        let table = typeof this.tableRef == "undefined" ? null : $(this.tableRef.nativeElement);

        if (table != null) {

            let fstRows = table.find('tbody').first().find('tr').first().find('td');
            let lstRows = table.find('tbody').last().find('tr').last().find('td');

            if (fstRows.length > 0 && lstRows.length > 0) {

                this.info.hd = typeof this.headerRef == "undefined" ? null : $(this.headerRef.nativeElement);
                this.info.ft = typeof this.footerRef == "undefined" ? null : $(this.footerRef.nativeElement);

                if (this.info.hd != null) {

                    this.info.hdHeight = this.info.hd.outerHeight();

                    this.info.hdMin = table.offset().top;
                    this.info.hdMax = lstRows.offset().top - this.info.hdMin - this.info.hdHeight;
                }

                if (this.info.ft != null) {

                    let minTop = fstRows.offset().top + fstRows.outerHeight();

                    this.info.ftMin = lstRows.offset().top + lstRows.outerHeight();
                    this.info.ftMax = this.info.ftMin - minTop;
                    this.info.ftHeight = this.info.ft.outerHeight();
                }
            }
        }
    }

    positioning() {

        if (this.info.hd != null) {

            let pos = Math.min(Math.max(window.scrollY + this.info.nav - this.info.hdMin, 0), this.info.hdMax);

            if (pos > 0 && pos < this.info.hdMax) {
                this.info.hd.css({position: "fixed", top: this.info.nav});
            }
            else {
                this.info.hd.css({position: "absolute", top: pos});
            }
        }

        if (this.info.ft != null) {

            let pos = Math.min(Math.max(this.info.ftMin - window.scrollY - window.innerHeight + this.info.ftHeight, 0), this.info.ftMax);

            if (0 < pos && pos < this.info.ftMax) {
                this.info.ft.css({position: "fixed", bottom: 0});
            }
            else {
                this.info.ft.css({position: "absolute", bottom: pos});
            }
        }
    }

    public empty() {

        if (this.configs == null) return true;

        let length = 0;
        this.configs.forEach(i => length += this.valid(i) ? i.data.length : 0);

        return length < 1;
    }

    public filterable() {
        return this.config != null
            && typeof this.config.txt == 'function'
            && this.config.data != null
            && this.config.data.length > 0;
    }

    public groupable() {
        return this.groups != null
            && (this.groups.length > 1 || (this.groups.length == 1 && this.groups[0].children.length > 1));
    }

    public exportable() {
        return this.config != null
            && typeof this.config.xls == 'function';
    }

    public valid(config) {
        return config != null && config.data != null && config.columns != null && config.data.length > 0 && config.columns.length > 0;
    }

    public select() {

        let val = null;

        if (typeof this.selectRef == 'undefined') {
            for (let i = 0; i < this.configs.length; i++) {
                if (this.valid(this.configs[i])) {
                    val = i;
                    break;
                }
            }
        }
        else {
            val = $(this.selectRef.nativeElement).val();
        }

        this.config = this.configs[val];

        this.data = this.filtered = this.config.data;

        this.footer = typeof this.config != "undefined" && typeof this.config.footer == "function" ? this.config.footer(this.filtered) : null;

        if (typeof this.searchRef != 'undefined') $(this.searchRef.nativeElement).val('');

        if (typeof this.config != 'undefined' && typeof this.config.group == 'function') {

            let buffer = {};

            this.data.forEach(i => {

                let info = this.config.group(i);

                if (typeof buffer[info.parent] == 'undefined') buffer[info.parent] = {};
                buffer[info.parent][info.html] = true;
            });

            this.groups = [];
            for (let o in buffer) {
                let child = {html: o, selected: true, children: []};
                for (let i in buffer[o]) child.children.push({html: i, selected: true});

                child.children = child.children.sort((a, b) => a.html > b.html ? 1 : a.html < b.html ? -1 : 0);

                this.groups.push(child);
            }

            this.groups = this.groups.sort((a, b) => a.html > b.html ? 1 : a.html < b.html ? -1 : 0);
        }
        else {
            this.groups = null;
        }
    }

    public css(col: DataTableColumnDef, item: any): string {
        let classes = [];

        if (typeof col.css == 'function') classes.push(col.css(item));
        if (typeof col.click == 'function') classes.push('clickable');

        return classes.join(' ');
    }

    public click(col: DataTableColumnDef, item) {
        if (typeof col.click == 'function') col.click(item);
    }

    public update() {

        if (this.config.txt !== null) {
            let txt = this.toASCII($(this.searchRef.nativeElement).val());

            let selected = {};

            if (this.groups != null) this.groups.forEach(group => group.children.forEach(i => {
                if (i.selected) selected[i.html] = true
            }));

            this.filtered = this.data.filter(i => this.toASCII(this.config.txt(i)).indexOf(txt) > -1 && (this.groups == null || typeof selected[this.config.group(i).html] != 'undefined'));
            this.footer = typeof this.config.footer == 'function' ? this.config.footer(this.filtered) : null;
        }
    }

    private toASCII(str) {

        str = str.toLowerCase();
        str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
        str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
        str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
        str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
        str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
        str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
        str = str.replace(/đ/g, 'd');

        return str;
    }

    constructor() {
    }

    toggle(group, child) {

        if (child != null) {
            child.selected = !child.selected;

            let selected: any = false;
            group.children.forEach(i => selected |= i.selected);
            group.selected = selected;
        }
        else {
            group.selected = !group.selected;
            group.children.forEach(i => i.selected = group.selected);
        }
    }

    show(e) {
        e.preventDefault();
        $(this.popupRef.nativeElement).modal('show');
    }

    hide(e) {
        e.preventDefault();
        $(this.popupRef.nativeElement).modal('hide');
    }

    export(e) {

        let html = "<tr>";

        this.config.xls(null).forEach(col => {
            html += '<td>' + col + '</td>';
        });

        html += '</tr>';

        this.filtered.forEach(item => {

            html += '<tr>';

            this.config.xls(item).forEach(col => {
                html += '<td>' + col + '</td>';
            });

            html += '</tr>';
        });

        let uri = 'data:application/vnd.ms-excel,';
        let template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';

        let ctx = {
            worksheet: 'Worksheet',
            table: html
        }

        let link = document.createElement('a');
        link.download = this.config.title + '.xls';
        link.target = "_blank";
        link.href = uri + encodeURIComponent(template.replace(/{(\w+)}/g, (m, p) => ctx[p]));
        link.click();
    }
}

@Directive({
    selector: '[domChange]'
})
export class DomChangeDirective implements OnDestroy {
    private changes: MutationObserver;

    @Output()
    public domChange = new EventEmitter();

    constructor(private elementRef: ElementRef) {
        const element = this.elementRef.nativeElement;

        this.changes = new MutationObserver(mutations => this.domChange.emit(element));
        this.changes.observe(element, {childList: true, subtree: true});
    }

    ngOnDestroy() {
        this.changes.disconnect();
    }
}

export interface DataTableConfig {
    data: Array<any>;
    columns: Array<DataTableColumnDef>;

    txt?(data: any): string;

    group?(data: any): DataTableGroupDef;

    xls?(data: any): Array<string>;

    title?: string;
    hideTitle?: boolean;
    multibody?: boolean;
    count?: boolean;

    footer?(data: Array<any>): Array<DataTableFooterDef>;
}

export interface DataTableColumnDef {
    title: string;
    class?: string;
    visible?: boolean;

    css?(item: any): string;

    html(item: any): string;

    click?(item: any): void;

    width?: string
}

export interface DataTableFooterDef {
    html?: string,
    class?: string,
    visible?: boolean,
}

export interface DataTableGroupDef {
    html: string,
    parent: string;
}
